import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom, linkText } from '../../../helpers/getEmailStyles';

class ListPublishRequest extends React.Component {

	render() {
		const { content: { hostName, listId, listTitle, logo, siteName } } = this.props;
		let URL = url + `/become-a-host/${listId}/home`;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>
						Hi Admin,
					</div>
					<EmptySpace height={20} />
					<div>
						A new listing has been submitted by {hostName} for your review. Please check the details and take the necessary action.
					</div>
					<EmptySpace height={20} />
					<div>
						<a style={linkText} href={URL}>Click here</a> to proceed to the listing request section.
					</div>
					<EmptySpace height={20} />
					<div style={marginBottom}><span style={fontWeightBold}>Listing Details:-</span></div>
					<div style={marginBottom}><span style={fontWeightBold}>ID:</span> {listId}</div>
					<div><span style={fontWeightBold}>Title:</span> {listTitle}</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default ListPublishRequest;